// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

const MAX_REVIEWERS = 10;

export default class FormView extends JQueryView {
  constructor() {
    super('.modal-dialog');

    this.assignReviewerFieldIndex();
    this.toggleAddFieldButtonVisibility();
    this.toggleRemoveFieldButtonVisibility();
  }

  @on({ event: 'input', selector: '.reviewer-name-input' })
  handleReviewerNameInputInput(e: any) {
    /*
      NOTE:
      $('option[label="' + $(e.target).val() + '"]').data('email') <- 入力された氏名のemail(手動入力用)
      $('option[value="' + $(e.target).val() + '"]').data('email') <- 選択されたemailのemail(optionからの選択用)
      $('option[value="' + $(e.target).val() + '"]').data('name') <- 選択されたemailの氏名(optionからの選択用)

      datalistのoptionの仕様上、同じvalue(同姓同名)の場合、区別することができない。
      その対策のためにoption選択時はemailが送られてくるようにしている。
      つまり、optionから選択された時は`$(e.target).val()`の値はメールアドレスである。
      そして、メールアドレスを元にメンバーを特定している。
    */
    const email =
      $('option[label="' + $(e.target).val() + '"]').data('email') ||
      $('option[value="' + $(e.target).val() + '"]').data('email');
    const name =
      $('option[value="' + $(e.target).val() + '"]').data('name') ||
      $(e.target).val();

    $(e.target).val(name);

    if (email) {
      const $reviewerEmailInput = $(e.target)
        .closest('.reviewer-field')
        .find('.reviewer-email-input');

      $reviewerEmailInput.val(email);
      $reviewerEmailInput.focus();
      $(e.target).focus();
    }

    if ($(e.target).val()) {
      $(e.target).addClass('reviewer-name-input__hide-dropdown');
    } else {
      $(e.target).removeClass('reviewer-name-input__hide-dropdown');
    }
  }

  @on({ event: 'focus', selector: '.reviewer-name-input' })
  handleReviewerNameInputFocus(e: any) {
    if ($(e.target).val()) {
      $('option').prop('disabled', true);
      $(e.target).addClass('reviewer-name-input__hide-dropdown');
    } else {
      $('option').prop('disabled', false);
      $(e.target).removeClass('reviewer-name-input__hide-dropdown');
    }
  }

  @on({ event: 'mousedown', selector: '.reviewer-name-input' })
  handleReviewerNameInputMouseDown(e: any) {
    if ($(e.target).val()) {
      $('option').prop('disabled', true);
      $(e.target).addClass('reviewer-name-input__hide-dropdown');
    } else {
      $('option').prop('disabled', false);
      $(e.target).removeClass('reviewer-name-input__hide-dropdown');
    }
  }

  @on({ event: 'click', selector: '.add-field-button' })
  handleAddFieldButtonClick(e: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(e.target).data('id'), 'g');

    $('.reviewer-fields').append(
      $(e.target)
        .data('field')
        .replace(regexp, time),
    );

    this.assignReviewerFieldIndex();
    this.toggleAddFieldButtonVisibility();
    this.toggleRemoveFieldButtonVisibility();
  }

  @on({ event: 'click', selector: '.remove-field-button' })
  handleRemoveFieldButtonClick(e: any) {
    $(e.target)
      .parent()
      .remove();

    this.assignReviewerFieldIndex();
    this.toggleAddFieldButtonVisibility();
    this.toggleRemoveFieldButtonVisibility();
  }

  @on({ event: 'click', selector: '#back-button' })
  onClickBackButton() {
    $('#form-modal').modal('hide');
    if ($('#select-modal').length) $('#select-modal').modal('show');
  }

  assignReviewerFieldIndex() {
    $('.reviewer-field').each((index, element) => {
      $(element)
        .find('.reviewer-field-index')
        .text(index + 1);
    });
  }

  toggleRemoveFieldButtonVisibility() {
    if ($('.reviewer-field').length > 1) {
      $('.remove-field-button').show();
    } else {
      $('.remove-field-button').hide();
    }
  }

  toggleAddFieldButtonVisibility() {
    if ($('.reviewer-field').length === MAX_REVIEWERS) {
      $('.add-field-button').hide();
    }

    if (
      $('.reviewer-field').length < MAX_REVIEWERS &&
      $('.add-field-button').is(':hidden')
    ) {
      $('.add-field-button').show();
    }
  }
}
